<template>
  <b-modal ref="aePrivileges" scrollable size="lg" id="edit_privileges" title="Edit Privileges" @ok="privOK" @cancel="privCancel" @close="privClose">
    <div v-if="users.length>0">
      <p>
        <label class="text-dark" id="privileges_for">Privileges For:</label>
        <select v-model="user" class="fullWidth" id="ddlPrivilegesFor">
          <option v-for="u in users" v-bind:value="u.ClientID">{{u.Name}}</option>
        </select>
      </p>

      <p class="mt-3">
        <span v-show="allowPool===true"><input type='radio' name='typeSelector' value='typPool' v-model="permScope" @click="setPermWholePool" /> <span id="whole_pool">Whole Pool</span><br /></span>
        <input type='radio' name='typeSelector' value='typGroup' v-model="permScope" @click="setPermGroup" /> <span id="specific_group">Specific Group(s)</span>
      </p>

      <div v-show="permScope==='typGroup' && isSSOUser===true">
        <hr />
        <span name="group">Group</span>: <select v-model="groupID" class="fullWidth" id="ddlPrivilegeGroup">
          <option v-for="group in groups" v-bind:value="group.LicensePoolGroupID" v-show="group.ParentID !== '00000000-0000-0000-0000-000000000000'">{{group.LicensePoolGroupName}}</option>
        </select>
        <hr />
      </div>
      <div v-show="permScope==='typGroup' && isSSOUser===false">
        <hr />
        <span name="group">Group</span>: <select v-model="groupID" class="fullWidth" id="ddlPrivilegeGroup2">
          <option v-for="group in groups" v-bind:value="group.LicensePoolGroupID">{{group.LicensePoolGroupName}}</option>
        </select>
        <hr />
      </div>
      <p class="mt-3" v-if="boundelement!==null">
        <input type='radio' name='privilegeSelector' value="-" v-model="boundelement.AdminType" /> <b id="no_privileges">No Privileges</b>: <span id="no_privileges_desc">The member cannot access this resource</span><br />
        <input type='radio' name='privilegeSelector' value="Data-Viewer" v-model="boundelement.AdminType" /> <b id="data_viewer">Data-Viewer</b>: <span id="data_viewer_desc">The member can only view data records</span><br />
        <input type='radio' name='privilegeSelector' value="Administrator" v-model="boundelement.AdminType" /> <b id="administrator">Administrator</b>: <span id="administrator_desc">The member can also add/delete/modify records</span>
      </p>


    </div>
  </b-modal>
</template>

<script>
  export default {
    name: "EditPrivileges",
    props: ["poolID", "allowPool"],
    data() {
      return {
        boundelement: null,
        groupID: this.emptyguid,
        groups: [],
        permScope: 'typPool',
        user: null,
        users: [],
        userprivs: [],
        isSSOUser: false
      }
    },
    methods: {
      addUserCmd(priv) {
        if (this.permScope === 'typPool' && priv.Type === 'p') {
          return {
            Operation: "LicensePool",
            Function: "AddPrivilegedUser",
            Fields: {
              LicensePoolID: this.poolID,
              ClientID: this.user,
              Privilege: priv.AdminType === 'Data-Viewer' ? 0 : 1
            }
          };
        }
        else if (this.permScope === 'typGroup' && priv.Type === 'g') {
          return {
            Operation: "LicensePool",
            Function: "AddPrivilegedGroupUser",
            Fields: {
              LicensePoolID: this.poolID,
              ClientID: this.user,
              Privilege: priv.AdminType === 'Data-Viewer' ? 0 : 1,
              LicensePoolGroupID: priv.GroupID,
              ParentID: priv.ParentID
            }
          };
        }
        return null;
      },
      calibratePerms() {
        this.boundelement = null;
        this.groupID = null;
        if (this.user === null) return;
        var hasPool = null
        var hasGroup = null;

        for (var priv of this.userprivs) {

          if (priv.GroupID === this.emptyguid && this.allowPool) {
            priv.Type = 'p';
            priv.Generated = false;
            hasPool = priv;
          }

          if (priv.GroupID !== this.emptyguid) {
            priv.Type = 'g';
            priv.Generated = false;
            hasGroup = priv;
          }
        }

        

        if (hasPool !== null) {

          this.permScope = 'typPool';

          this.boundelement = hasPool;
        }
        else if (hasGroup !== null) {

          if (this.allowPool) {
            this.userprivs.push({
              AdminType: '-',
              GroupID: this.emptyguid,
              Type: 'p',
              Generated: true
            });
          }

          this.permScope = 'typGroup';

          this.groupID = hasGroup.GroupID;
        }
        else {
          if (this.allowPool) {
            this.userprivs.push({
              AdminType: '-',
              GroupID: this.emptyguid,
              Type: 'p',
              Generated: true
            })

            this.boundelement = this.userprivs[0];
            this.permScope = 'typPool';
          }
          else {
            this.groupID = this.emptyguid;
          }
        }


        for (var grp of this.groups) {
          if (grp.LicensePoolGroupID !== this.emptyguid) {
            if (this.userprivs.filter(p => p.GroupID === grp.LicensePoolGroupID && p.Type === 'g').length === 0) {
              this.userprivs.push({
                AdminType: '-',
                GroupID: grp.LicensePoolGroupID,
                Type: 'g',
                Generated: true,
                ParentID: grp.ParentID
              })
            }
          }
        }


      },
      deleteUserCmd(priv) {
        if (priv.Type === 'g') {
          return {
            Operation: "LicensePool",
            Function: "DeletePrivilegedGroupUser",
            Fields: {
              LicensePoolGroupAdministratorID: priv.AdminID,
              ClientID: this.user,
              LicensePoolID: this.poolID,
              ParentID: priv.GroupID
            }
          };
        }
        else {
          return {
            Operation: "LicensePool",
            Function: "DeletePrivilegedUser",
            Fields: {
              LicensePoolAdministratorID: priv.AdminID,
              ClientID: this.user,
              LicensePoolID: this.poolID
            }
          };
        }
      },
      doAddPrivs(acmds) {
        this.apiCommand(acmds).then(r => {

          this.popDialog(0, "Privileges saved");
          this.user = null;
          this.$parent.render(true);

        })
      },
      doDeletePrivs(dcmds, acmds) {
        this.apiCommand(dcmds).then(r => {
          if (acmds.length > 0) {
            this.doAddPrivs(acmds);
          }
          else {
            this.popDialog(0, "Privileges saved");
            this.user = null;
            this.$parent.render(true);

          }
        })
      },
      privCancel() {
        this.user = null;
      },
      privClose() {
        this.user = null;
      },
      privOK() {


        var acmds = [];
        var dcmds = [];
        for (var priv of this.userprivs) {
          if (!priv.Generated) {
            dcmds.push(this.deleteUserCmd(priv));
            if (priv.AdminType !== '-') {
              var v = this.addUserCmd(priv);
              if (v !== null) {
                acmds.push(v);
              }
            }
          }
          else {
            if (priv.AdminType !== '-') {
              var v = this.addUserCmd(priv);
              if (v !== null) {
                acmds.push(v);
              }
            }
          }
        }


        if (dcmds.length > 0) {
          this.doDeletePrivs(dcmds, acmds);
        }
        else {
          if (acmds.length > 0) {
            this.doAddPrivs(acmds);
          }
          else {
            this.popDialog(1, "No changes were made");
            this.user = null;
          }
        }


      },
      setPermGroup() {
        this.groupID = this.emptyguid;
        this.boundelement = null;
        setTimeout(Window.loadLanguageContent(), 5000);
      },
      setPermWholePool() {
        this.groupID = this.emptyguid;
        for (var priv of this.userprivs) {
          if (priv.GroupID === this.emptyguid) {
            this.boundelement = priv;
            console.log(this.boundelement);
            setTimeout(Window.loadLanguageContent(), 5000);
          }
        }
      },
    },
    mounted() {
      if (this.allowPool === false) {
        this.permScope = 'typGroup';
      }

      if (sessionStorage.getItem("isSimmersionUser")) {
        this.isSSOUser = true;
      }

    },
    watch: {
      groupID: function () {


        for (var priv of this.userprivs) {
          if (priv.GroupID === this.groupID && this.groupID !== this.emptyguid) {
            this.boundelement = priv;

          }
        }
        setTimeout(Window.loadLanguageContent(), 5000);

      },
      user: function () {
        if (this.user === null || this.user === this.emptyguid) {
          this.groupID = null;
          return;
        }

        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetPrivilegesForUser",
            Fields: {
              LicensePoolID: this.poolID,
              ClientID: this.user
            }
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          this.userprivs = JSON.parse(cr.returnObjects[0].returnObject);          
          this.calibratePerms();          
          setTimeout(Window.loadLanguageContent(), 5000);
        })
      }
    }
  }
</script>
